import React from 'react';
import { SiMongodb, SiExpress, SiRedux } from 'react-icons/si';
import { FaReact, FaNode } from 'react-icons/fa';
import { technologies } from './data';
import './Marquee.css';

const Marquee = () => {
  return (
    <div className="marquee">
      <ul className="marquee__content">
        {technologies.map((technology) => {
          const { id, icon } = technology;
          return <li key={id}>{icon}</li>;
        })}
        <li>
          <SiMongodb />
        </li>
        <li>
          <SiExpress />
        </li>
        <li>
          <FaReact />
        </li>
        <li>
          <FaNode />
        </li>
        <li>
          <SiRedux />
        </li>
      </ul>
    </div>
  );
};

export default Marquee;
